import { getQueryParam } from "./route-util";
import { getItem, removeItem, setItem } from "./local-storage";
import { STORAGE_KEYS } from "../config";
import { UTM_PARAMETERS, UTMParameters } from "shared";

/**
 * Returns the UTM from the URL.
 */
export function getUTMFromURL(): UTMParameters {
	const utm: Record<string, string> = {};

	// Add utm
	for (const key of UTM_PARAMETERS) {
		const value = getQueryParam(key);
		if (value != null) {
			utm[key] = value;
		}
	}

	// Add referer
	const referer = document.referrer;
	if (referer.length > 0) {
		utm["referer"] = referer;
	}

	return utm;
}

/**
 * Saves the UTM to storage if there is one present in the URL.
 */
export function saveUTM() {
	const utm = getUTMFromURL();
	if (Object.keys(utm).length > 0) {
		setItem(STORAGE_KEYS.utm, utm);
	}
}

/**
 * Loads the UTM from storage.
 */
export function loadUTM(): UTMParameters {
	return getItem<UTMParameters>(STORAGE_KEYS.utm) ?? {};
}

/**
 * Removes UTM from storage.
 */
export function clearUTM() {
	removeItem(STORAGE_KEYS.utm);
}
